module.exports = __webpack_public_path__ + "img/loading.107da96e.gif";